export const playerCloudHandoffFragmentPrefix = "#qassist-cloud-handoff=";
export const playerCloudLinkNeededFragment = "#qassist-cloud-link-needed";

export function playerCloudHandoffToken(hash: string): string | null {
  let normalizedHash = hash;
  try {
    normalizedHash = decodeURIComponent(hash);
  } catch {
    return null;
  }
  if (!normalizedHash.startsWith(playerCloudHandoffFragmentPrefix)) return null;
  const token = normalizedHash.slice(playerCloudHandoffFragmentPrefix.length);
  return /^[A-Za-z0-9_-]{43,128}$/.test(token) ? token : null;
}

export function playerLocationWithoutFragment(location: {
  pathname: string;
  search: string;
}): string {
  return `${location.pathname}${location.search}`;
}
